import React, {Component} from 'react';
import Grid from '@material-ui/core/Grid';
import ProfileAccount from '../components/profile/ProfileAccount';
import Paper from '@material-ui/core/Paper';

export default class account extends Component {
  render() {
    // console.log(this.props);
    // check if user is logged in
    const token = localStorage.FBIdToken;
    if (token) {
      return (
        <Grid container spacing={16}>
          <Grid item sm={6} xs={12}>
            <ProfileAccount />
          </Grid>
          <Grid item sm={6} xs={12}>
            <Paper className=''>
              Link 1
              <br />
              Link 2
              <br />
              Link 3
              <br />
              Link 4
            </Paper>
          </Grid>
        </Grid>
      );
    } else {
      window.location.href = '/login';
    }
  }
}
